// extracted by mini-css-extract-plugin
export default {"container":"nC-z","dimension":"oC-z","dimensionLabels":"pC-z"};